import axios, { getData } from "lib/axios";
import { useMutation, useQuery, useQueryClient } from "react-query";

const LEAVE_APPROVAL_COUNT_LIMIT = 10000;

export const useGetAllLeaveApproval = (query = {}) => {
  const { limit, status, type, page } = query;

  return useQuery("leave-approval", async () => {
    if (Object.keys(query).length !== 0 && query.constructor === Object) {
      const res = await axios
        .get(
          `/leave-approval?status=${status}&limit=${limit}&type=${type}&page=${page}`
        )
        .then(getData);
      return res.data;
    } else {
      const res = await axios.get(`/leave-approval`).then(getData);
      return res.data;
    }
  });
};

export const useGetAllFilteredLeaveApproval = (query = {}) => {
  const { status, limit = 5, page = 1, sortBy, sortOrder } = query;

  return useQuery(["leave-approval", status, limit, page, sortBy, sortOrder], async () => {
    if (Object.keys(query).length !== 0 && query.constructor === Object) {
      const res = await axios
        .get("/leave-approval", {
          params: {
            status,
            limit,
            page,
            sort_by: sortBy,
            sort_order: sortOrder,
          },
        })
        .then(getData);
      return res.data;
    } else {
      const res = await axios.get(`/leave-approval`).then(getData);
      return res.data;
    }
  });
};

export const getFilteredLeaveApproval = async ({
  status,
  page = 1,
  limit = 5,
  sortBy,
  sortOrder,
}) => {
  return axios
    .get("/leave-approval", {
      params: {
        status,
        limit,
        page,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
    })
    .then(getData);
};

export const getFilteredLeaveApprovalTotal = async ({ status }) => {
  return axios
    .get("/leave-approval", {
      params: {
        status,
        limit: LEAVE_APPROVAL_COUNT_LIMIT,
        page: 1,
      },
    })
    .then(getData);
};

// To approve or reject in leave approval
export const usePutLeaveApproval = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, postData, requestId }) => {
      const res = await axios.put(`/leave-approval/${id}`, postData);
      return res;
    },
    {
      onSuccess: (data, { requestId }) => {
        queryClient.invalidateQueries("leave-approval");
        queryClient.invalidateQueries("leave-approval-responded");
        queryClient.invalidateQueries("leave-approval-responded-total");
        queryClient.invalidateQueries("leave-request", requestId);
      },
    }
  );
};
